<script>
  import { onMount, onDestroy } from 'svelte';
  import Chart from 'chart.js/auto';

  export let title = 'Analytics';
  export let subtitle = '';
  export let data = [];
  export let labels = [];
  export let height = 300;

  let chartCanvas;
  let chart;

  onMount(() => {
    if (!chartCanvas) return;

    const ctx = chartCanvas.getContext('2d');

    chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: title,
          data: data,
          backgroundColor: 'rgba(59, 130, 246, 0.8)',
          borderColor: 'rgba(59, 130, 246, 1)',
          borderWidth: 1,
          borderRadius: 4,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        }
      }
    });
  });

  onDestroy(() => {
    if (chart) {
      chart.destroy();
    }
  });

  $: if (chart && data && labels) {
    chart.data.labels = labels;
    chart.data.datasets[0].data = data;
    chart.update();
  }
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <div class="flex items-center justify-between mb-4">
    <div>
      <h3 class="text-lg font-semibold text-gray-900">{title}</h3>
      {#if subtitle}
        <p class="text-sm text-gray-500">{subtitle}</p>
      {/if}
    </div>

    <div class="flex gap-2">
      <button class="px-3 py-1 text-xs font-medium text-gray-600 hover:bg-gray-100 rounded">12 months</button>
      <button class="px-3 py-1 text-xs font-medium text-gray-600 hover:bg-gray-100 rounded">30 days</button>
      <button class="px-3 py-1 text-xs font-medium text-gray-600 hover:bg-gray-100 rounded">7 days</button>
      <button class="px-3 py-1 text-xs font-medium bg-blue-50 text-blue-600 rounded">24 Hours</button>
    </div>
  </div>

  <div style="height: {height}px;">
    <canvas bind:this={chartCanvas}></canvas>
  </div>
</div>
